<!-- Loading bar -->
<hippo-loading-bar></hippo-loading-bar>

<!-- Navigation -->
<hippo-vertical-navigation
    class="dark bg-[#062C52] print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container hippoVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center h-20 p-4 pb-0 mb-5">
            <a
                href="/"
                target="_blank">
                <img
                    class="flex w-30"
                    src="assets/images/logos/hippo-data.png"
                    alt="Logo image"
                    usemap="#inspector" />
                <map
                    name="inspector"
                    class="cursor-pointer">
                    <area
                        shape="poly"
                        coords="48,16,67,10,71,23,71,29,56,34,52,29"
                        (click)="openInspector($event)" />
                </map>
            </a>
        </div>
    </ng-container>
</hippo-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 shadow dark:shadow-none dark:border-b bg-white print:hidden"
        [ngClass]="{'z-49':isScreenSmall,'z-[250]':!isScreenSmall}">
        <!-- Navigation toggle button -->

        @if (isScreenSmall) {
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        } @else {
            @if (navigationOpened) {
                <button
                    mat-icon-button
                    (click)="toggleNavigation('mainNavigation')" class="translate-x-[-45px] z-[250]">
                    <div
                        class="bg-[#062C52] rounded-full border-2 border-[#8CAACD] flex justify-center items-center w-7 h-7">
                        <mat-icon
                            [svgIcon]="'mat_outline:chevron_left'"
                            class="text-white"></mat-icon>
                    </div>
                </button>
            } @else {
                <button
                    mat-icon-button
                    (click)="toggleNavigation('mainNavigation')">
                    <div
                        class="bg-[#062C52] rounded-full border-2 border-[#8CAACD] flex justify-center items-center w-7 h-7">
                        <mat-icon
                            [svgIcon]="'mat_outline:chevron_right'"
                            class="text-white"></mat-icon>
                    </div>
                </button>
            }
        }
        <div class="font-bold ml-6 truncate" [ngClass]="{'translate-x-[-45px]':!isScreenSmall&&navigationOpened}">
            <span
                *ngFor="
                    let headlineItem of headlineService.headline;
                    let last = last
                ">
                <ng-container *ngIf="headlineItem.includes('$$')">
                    {{
                        (headlineItem.split('$$')[0] ?? '' | transloco).replace(
                            headlineItem.split('$$')[1] ?? '',
                            headlineItem.split('$$')[2] ?? ''
                        )
                    }}
                </ng-container>
                <ng-container *ngIf="!headlineItem.includes('$$')">
                    {{ headlineItem | transloco }}
                </ng-container>
                <span *ngIf="!last">&nbsp;>&nbsp;</span>
            </span>
        </div>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <mat-checkbox
                *ngIf="environment.isTestSystem || headlineService.enabled"
                class="hidden md:block"
                [matTooltip]="
                    translocoService.getActiveLang() === 'de'
                        ? 'Altes System'
                        : 'Old system'
                "
                [(ngModel)]="headlineService.showIframe"
                (change)="headlineService.toggleOldSystem()">
                {{ translocoService.getActiveLang() === 'de' ? 'Alt' : 'Old' }}
            </mat-checkbox>
            <languages></languages>
            <hippo-fullscreen class="hidden md:block"></hippo-fullscreen>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer
    <div
        class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary"
            >hippo data &copy; {{ currentYear }}</span
        >
    </div>-->
</div>
